<template>
  <div
    ref="title-container"
    v-overflow-title="header"
    class="m-table-header-default"
    :class="{'m-table-header-default_medium-font': fontSize === 'M'}"
  >
    <MIcon
      v-if="icon"
      :icon="icon"
      class="m-table-header-default__icon"
    />
    {{ header }}
    <div
      v-show="overflows"
      class="m-table-header-default__shadow"
    />
  </div>
</template>

<script>
  import MIcon from 'components/Design/MIcon';
  import nextFrame from 'utils/nextFrame';
  import _ from 'lodash';
  _.noConflict();

  export default {
    name: 'MTableHeaderDefault',
    components: {MIcon},
    props: {
      header: {
        type: String,
        default: ''
      },
      icon: {
        type: Object,
        default: null
      },
      fontSize: {
        type: String,
        required: true
      },
      unit: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        overflows: false
      };
    },
    mounted () {
      nextFrame(() => {
        const el = this.$refs['title-container'];
        if (!el) {

          /*
           * do nothing if element was destroyed (F.E. Page was quickly changed)
           * OR
           * el may be undefined if component is rendered but not added to it's parent
           */
          return;
        }

        if ('ResizeObserver' in window){
          const observer = new ResizeObserver(() => {
            this.throttledCheckOverflow();
          });
          observer.observe(el);
          this.$on('hook:destroyed', () => {
            observer.disconnect();
          });
        }

        nextFrame(() => {
          this.checkOverflow();
        });
      });
    },
    methods: {
      checkOverflow () {
        if (!this.$refs['title-container']) {
          return;
        }
        const el = this.$refs['title-container'];
        this.overflows = el.scrollWidth > el.offsetWidth;
      },
      throttledCheckOverflow: _.throttle(function () {
        this.checkOverflow();
      }, 150)
    }
  };
</script>

<style>
  .m-table-header-default {
    font-weight: var(--medium-font-weight);

    overflow: hidden;

    position: relative;

    width: 100%;
    max-height: 42px;
  }

  .m-table-header_superheader .m-table-header-default {
    font-weight: var(--main-font-weight);

    color: var(--panel-text-color);

    display: flex;

    justify-content: center;
    align-items: center;
  }

  .m-table-header-default_medium-font {
    max-height: 64px;
  }

  .m-table-header-default__shadow {
    position: absolute;
    top: 0;
    right: 0;

    height: 100%;

    box-shadow: 0 0 8px 8px var(--background-color);
  }

  .m-table-header-default__icon {
    flex-grow: 0;
    flex-shrink: 0;

    width: 12px;
    height: 12px;

    margin-right: 2px;
  }

  .m-table-header-default__help {
    display: inline;
  }
</style>
